import { deepMerge } from '@opallabs/lambda'
import { testFeature } from '@opallabs/principles'

export const allowedContent: Record<string, Array<string>> = {
  all: ['asset_and_copy', 'document'],
  bluesky: ['bluesky_gif', 'bluesky_standard', 'bluesky_video'],
  facebook: ['facebook_story', 'reel', 'standard'],
  instagram: [
    'expandable_story_link_ad',
    'instagram_carousel_ad',
    'instagram_carousel_app_ad',
    'instagram_carousel',
    'instagram_story',
    'native_story_link_ad',
    'photo',
    'reel',
    'story_link_ad',
    'video',
  ],
  linked_in: ['document_post', 'linkedin_article'],
  reddit: ['promoted_post'],
  sharepoint: ['sharepoint_document'],
  sms_message: ['sms'],
  snapchat: ['photo'],
  threads: ['standard'],
  tiktok: ['tiktok_carousel', 'video'],
  twitter: [
    'gif',
    'moment',
    'retweet',
    'standard',
    'thread',
    'page_update',
    'video',
  ],
  you_tube: ['youtube_short', 'channel_update'],
}

const contentInDevelopment: Record<string, Array<string>> = {}

export const shouldShowContent = (service: string, postType: string) => {
  const accessibleContent = testFeature('show_in_development_content')
    ? deepMerge(allowedContent, contentInDevelopment)
    : allowedContent

  const serviceSpecificType =
    accessibleContent[service]?.includes(postType) ?? false
  const allServiceType = accessibleContent.all.includes(postType) ?? false

  return serviceSpecificType || allServiceType
}
